import type { TFunction } from "i18next";
import { checkKindText, MODEL_CHECK_IDS } from "../checks/checkKinds";

/**
 * A check that passed at the base and fails now, never by its ID (vocabulary review row 15): an item's check by its
 * item, which the row names before this text; a model check by its kind; else as "a check".
 */
export function regressedText(regression: { readonly checkId: string; readonly hasItem: boolean }, t: TFunction): string {
  if (regression.hasItem) return t("reviews.conflicts.regressedItem");
  if (MODEL_CHECK_IDS.has(regression.checkId)) return t("reviews.conflicts.regressed", { check: checkKindText(regression.checkId, t) });
  return t("reviews.conflicts.regressedUnnamed");
}
